module.exports = __webpack_public_path__ + "static/media/Spiderman.204ee4ee.png";